import { errorLogService } from '../services/errorLogService';

/**
 * エラーロガーユーティリティ
 * console.errorの代わりに使用することで、バックエンドにもエラーを送信
 */
class ErrorLogger {
  /**
   * エラーをログに記録（ブラウザコンソール + バックエンド）
   * @param {string} context - エラー発生箇所（例: '[LOGIN FORM]'）
   * @param {string} message - エラーメッセージ
   * @param {Error|Object} error - エラーオブジェクト（オプション）
   */
  log(context, message, error = null) {
    // ブラウザのコンソールに出力
    if (error) {
      console.error(context, message, error);
    } else {
      console.error(context, message);
    }

    // バックエンドに送信（非同期、結果を待たない）
    this.sendToBackend(context, message, error);
  }

  /**
   * エラー情報をバックエンドに送信
   * @private
   */
  async sendToBackend(context, message, error) {
    try {
      const errorData = {
        message: `${context} ${message}`,
        context: context,
        stack: error?.stack || null,
        url: window.location.href,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString()
      };

      // 非同期で送信（結果は待たない）
      await errorLogService.logError(errorData);
    } catch (e) {
      // 送信失敗は無視（コンソールには出ている）
    }
  }

  /**
   * Errorオブジェクトをログに記録
   * @param {string} context - エラー発生箇所
   * @param {Error} error - エラーオブジェクト
   */
  logError(context, error) {
    this.log(context, error.message, error);
  }

  /**
   * 警告をログに記録（console.warnのみ、バックエンドには送信しない）
   * @param {string} context - 発生箇所
   * @param {string} message - 警告メッセージ
   */
  warn(context, message) {
    console.warn(context, message);
  }

  /**
   * 情報をログに記録（console.logのみ、バックエンドには送信しない）
   * @param {string} context - 発生箇所
   * @param {string} message - 情報メッセージ
   */
  info(context, message) {
    console.log(context, message);
  }
}

// シングルトンインスタンスをエクスポート
export const errorLogger = new ErrorLogger();

/**
 * 任意の値を安全に文字列化する
 *
 * throw された値は Error に限らない。プロトタイプを持たないオブジェクトなどは
 * String() 自体が TypeError になるため、エラー表示側で落ちないようにする
 *
 * @param {unknown} error - 文字列化したい値
 * @returns {string} 表示用の文字列
 */
export const describeError = (error) => {
  if (error instanceof Error) return error.stack || error.message;
  try {
    return String(error?.message ?? error);
  } catch (e) {
    return '不明なエラー';
  }
};